import styled from 'styled-components';
import { Spacing8 } from 'autogen/design-tokens/tokens';
import ColorPalette from './components/ColorPalette/ColorPalette';
import ChanelDropdown from './components/Dropdown';
import type { ChanelProductVariants } from './shared/types';

const Wrapper = styled.div`
    display: grid;
    gap: ${Spacing8};
`;

export default function ChanelProductVariants(props: ChanelProductVariants) {
    const { displayColorSwatches } = props;

    return (
        <Wrapper>
            <ChanelDropdown {...props} />
            {displayColorSwatches && <ColorPalette {...props} />}
        </Wrapper>
    );
}
